<template><div><h1 id="do-dokumente-zuordnung" tabindex="-1"><a class="header-anchor" href="#do-dokumente-zuordnung"><span>DO Dokumente, Zuordnung</span></a></h1>
<p>DO Dokumente, Zuordnung — Dokumente im Dokumentensatz</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Maske werden die <RouteLink to="/referenz/refs/ft.refdata.do-dokumente.html" title="Dokumente, Stammtabelle">Dokumente</RouteLink> dem <RouteLink to="/referenz/refs/ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</RouteLink> zugeordnet. Es werden auch zusätzliche Parametrisierungen wie Druckerauswahl, Anzahl Kopien usw. vorgenommen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Document Output → Dokumentensätze</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Sort</dt>
<dd>Reihenfolge der Ausgabe (z.B. auf Drucker)</dd>
<dt>Status</dt>
<dd>Nur aktive Dokumente werden bei der Verarbeitung berücksichtigt</dd>
<dt>Dokument</dt>
<dd>Kurzbezeichnung des Dokumentes</dd>
<dt>Typ</dt>
<dd>Art des Dokumentes (Z.B. pdf oder E-Mail)</dd>
<dt>XSLT</dt>
<dd>XSL-Stylesheet, welches Daten und Formatierungsinformationen für die einzelnene Dokumnente enthält.</dd>
<dt>Drucker</dt>
<dd>ID des Druckers worauf die Dokumente ausgegeben werden sollen</dd>
<dt>Kopien</dt>
<dd>Anzahl Kopien, die vom betreffenden Dokument ausgegeben werden sollen</dd>
<dt>kopien von Feld</dt>
<dd>Referenziert einen XML-Tag aus dem Dokument , welcher die Anzahl Kopien vorgibt</dd>
<dt>Fach</dt>
<dd>Schacht des Ausgabedruckers</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink></p>
</div></template>


